import serverInterface from 'server-interface';

class WindowMessagingManager {

  constructor(application) {

    this.application = application;

    window.addEventListener('message', this.handleIncomingMessage.bind(this));

  }

  handleMessageFromAuthenticator(event) {

    window.location.href = event.data.redirectTo;

    event.source.postMessage({ close: true }, event.origin);

  }

  async sendAssistantAuthorization(event) {

    const authorization = await serverInterface.startup.users.getAssistantAuthorization();

    event.source.postMessage({ type: 'AUTHORIZATION', authorizationToken: authorization.token }, event.origin);

  }

  handleMessageFromAssistant(event) {

    const payload = event.data;
    const type = payload.type;

    if (type === 'GET_AUTHROIZATION') {
      this.sendAssistantAuthorization(event);
    } else if (type === 'CLOSE_DIALOG') {
      this.application.assistantManager.assistant.closeHandler();
    } else if (type === 'BOT_READY') {
      this.application.assistantManager.setReady(true);
    } else if (type === 'BOT_MESSAGE') {
      this.application.assistantManager.copyMessageToClipboard(payload.message);
    }

  }

  isMessageFromAuthenticator(event) {
    return ['http://localhost:3002', 'http://auth.local.com:3002', 'https://auth.venturz.co', 'https://auth.development.venturz.co'].indexOf(event.origin) !== -1;
  }

  isMessageFromAssistant(event) {
    return import.meta.env.REACT_APP_ASSISTANT_BASE_ADDRESS.indexOf(event.origin) === 0;
  }

  handleIncomingMessage(event) {

    if (this.isMessageFromAuthenticator(event) === true) {
      this.handleMessageFromAuthenticator(event);
    } else if (this.isMessageFromAssistant(event) === true) {
      this.handleMessageFromAssistant(event);
    }

  }

}

export default WindowMessagingManager;